/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApplicationSearchOrderBy {
    Name = 'Name',
    Description = 'Description'
}


export function instanceOfApplicationSearchOrderBy(value: any): boolean {
    for (const key in ApplicationSearchOrderBy) {
        if (Object.prototype.hasOwnProperty.call(ApplicationSearchOrderBy, key)) {
            if (ApplicationSearchOrderBy[key as keyof typeof ApplicationSearchOrderBy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApplicationSearchOrderByFromJSON(json: any): ApplicationSearchOrderBy {
    return ApplicationSearchOrderByFromJSONTyped(json, false);
}

export function ApplicationSearchOrderByFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationSearchOrderBy {
    return json as ApplicationSearchOrderBy;
}

export function ApplicationSearchOrderByToJSON(value?: ApplicationSearchOrderBy | null): any {
    return value as any;
}

export function ApplicationSearchOrderByToJSONTyped(value: any, ignoreDiscriminator: boolean): ApplicationSearchOrderBy {
    return value as ApplicationSearchOrderBy;
}

